import { render, staticRenderFns } from "./BlockSubscribeForm.vue?vue&type=template&id=4e4d33fc&scoped=true&"
import script from "./BlockSubscribeForm.vue?vue&type=script&lang=ts&"
export * from "./BlockSubscribeForm.vue?vue&type=script&lang=ts&"
import style0 from "./BlockSubscribeForm.vue?vue&type=style&index=0&id=4e4d33fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d33fc",
  null
  
)

export default component.exports